import React from 'react';

import type { CarouselContextType } from '../ScrollingCarousel.types';

export const CarouselContext = React.createContext<CarouselContextType | null>(
  null
);
